import { useState } from "react";

export function SelfCheck({ t }) {
  const [checked, setChecked] = useState(() => t.checkItems.map(() => false));
  const count = checked.filter(Boolean).length;
  const toggle = (i) => setChecked((c) => c.map((v, j) => (j === i ? !v : v)));
  return (
    <div className="selfcheck" data-testid="self-check">
      <h3 className="h3">{t.checkT}</h3>
      <div className="selfcheck-grid">
        {t.checkItems.map((item, i) => (
          <label key={i} className={`selfcheck-item${checked[i] ? " is-on" : ""}`}>
            <input
              type="checkbox"
              checked={checked[i]}
              onChange={() => toggle(i)}
              data-testid={`self-check-item-${i + 1}`}
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
      {count >= 4 ? (
        <div className="selfcheck-ok" data-testid="self-check-ok">
          <p className="selfcheck-result">{t.checkOk}</p>
          <a href="#contact" className="btn" data-testid="self-check-cta">{t.ctaLabel}</a>
        </div>
      ) : (
        <p className="selfcheck-result" data-testid="self-check-result">{t.checkMsg.replace("{n}", count)}</p>
      )}
    </div>
  );
}
